<template lang="pug">
v-app
  //- @ЗАГЛУШКА
  .d-flex.justify-center.flex-column.align-center.full-width.full-height(v-if="blockedByUpdate")
    no-data(
      icon="$ui-time"
    )
      template(#text)
        h3 У нас крупное обновление системы, пока она побудет недоступной

  template(v-else)
    template(v-if="isTokenLoading")
      .absolute.top-0.left-0.full-height.full-width.ui-background(
        :style=`{
          zIndex: 10000,
        }`
      )
        .d-flex.justify-center.align-center.full-height.full-width
          text-loader

    dialogs-container(@hook:mounted="dialogsReady = true")
    signature-account-setup-dialog(v-if="dialogsReady")

    template(v-if="!isEmptyLayout")
      drawers-container
      welcome-dialog
      delete-account-dialog
      //- mobile-dialog
      mobile-dialog-safari(v-if="dialogsReady")
      user-check-duplicates-dialog
      duplicate-by-auth-service-dialog
      profile-unfilled-data-dialog
      cookie-agreement
      //- Старый виджет поддержки. Оставлен до завершения перехода на @irpsu/support.
      //- support-modal(
      //-   :project-id="$conf.isVcht ? 3 : 2"
      //- )

      support-widget-button
    component(:is="layout" v-slot="{ listeners, props }")
      router-view(v-bind="props" v-on="listeners")
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Empty from './layouts/empty.vue';
import Remaked from './layouts/remaked.vue';
import Redesign from './layouts/redesign.vue';
import UiDesign from './layouts/ui-design.vue';
import WelcomeDialog from '@/components/dialogs/welcome/WelcomeDialog.vue';
// import UserDuplicatesDialog from '@/modules/UserDuplicatesMerges/components/UserDuplicatesDialog.vue';
import CookieAgreement from './components/CookieAgreement.vue';
// import SupportModal from '@/components/SupportModal/index.vue';
import MobileDialog from '@/components/dialogs/MobileDialog.vue';
import MobileDialogSafari from '@/components/dialogs/MobileDialogSafari.vue';
import ProfileUnfilledDataDialog from './modules/UIDesign/Profile/components/ProfileUnfilledDataDialog.vue';
import DeleteAccountDialog from './modules/UserProfile/components/Profile/DeleteAccount/DeleteAccountDialog.vue';
import DuplicateByAuthServiceDialog from './components/dialogs/DuplicateByAuthServiceDialog.vue';
import UserCheckDuplicatesDialog from './modules/UserDuplicatesMerges/components/UserCheckDuplicatesDialog.vue';
import NoData from './packages/ui/components/NoData.vue';
import SignatureAccountSetupDialog from './modules/UIDesign/Auth/components/Dialogs/SignatureAccountSetupDialog.vue';

const ACCEPTED_EVERYONE_REDESIGN_NAME_ROUTES = [
  'event-landing-redesign',
  'event-stage-events-redesign',
  'event-exhibition',
  'exhibition-hall',
  'exhibition-exposition',
  'exhibition-request',
  'exhibition-request-new',
  'exhibition-request-exists',
  'public-expert',
  'public-certificate',
  'public-organization',
  'report',
  'event-certificate-browse',
];

export default {
  components: {
    Empty,
    Remaked,
    Redesign,
    UiDesign,
    WelcomeDialog,
    // UserDuplicatesDialog,
    CookieAgreement,
    // SupportModal,
    SupportWidgetButton: () => import('@/components/SupportWidgetButton.vue'),
    MobileDialog,
    MobileDialogSafari,
    ProfileUnfilledDataDialog,
    DeleteAccountDialog,
    DuplicateByAuthServiceDialog,
    UserCheckDuplicatesDialog,
    NoData,
    SignatureAccountSetupDialog,
  },
  data() {
    return {
      layout: this?.$router?.meta?.layout || 'empty',
      dialogsReady: false,

      blockedByUpdate: (this.isProduction && false) && !this.$store.getters.isAdminAccess,
    };
  },
  computed: {
    ...mapGetters({
      isAdminAccess: 'isAdminAccess',
      isTokenLoading: 'auth/isTokenLoading',
    }),
    isEmptyLayout() {
      return this.layout === 'empty';
    },
  },
  watch: {
    $route: {
      handler(value) {
        const {
          member,
          expert,
          trainer,
          certificate,
          moderator,
          organization,
          department,
          operator,
        } = this.$conf.ROLES;
        // if (
        //   this.$user.isAuthenticated &&
        //   this.$user.hasRoles([member, expert, trainer]) &&
        //   this.isExpiredEmail() &&
        //   value.path !== '/redesign/my-profile' &&
        //   value.path !== '/verify-email'
        // ) {
        //   this.$router.push({ name: 'my-profile' });
        // }

        this.layout = value.meta.layout || 'remaked';

        if (
          this.layout === 'redesign' &&
          this.$user.isAuthenticated &&
          !this.$user.hasRoles([member, certificate, expert]) &&
          !ACCEPTED_EVERYONE_REDESIGN_NAME_ROUTES.includes(value.name)
        ) {
          this.$router.push('/');
        }
        // if (
        //   this.layout === 'ui-design'
        //   && this.$user.isAuthenticated
        //   && !this.$user.hasRoles([
        //     moderator,
        //     organization,
        //     department,
        //     operator,
        //     expert,
        //     trainer,
        //   ])
        // ) {
        //   this.$router.push('/');
        // }
      },
    },
  },
  created() {
    window.addEventListener('keydown', this.switchAdminAccessByKeys);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('keydown', this.switchAdminAccessByKeys);
    });

    if (this.blockedByUpdate) {
      return;
    }
    this.init();
    // this.$rApi.directories.getGlobalDocumentsType();
  },
  methods: {
    ...mapActions({
      init: 'auth/init',
      switchAdminAccess: 'switchAdminAccess',
    }),
    switchAdminAccessByKeys(e) {
      const { code, altKey, ctrlKey } = e || {};
      if ((code === 'KeyA') && altKey && ctrlKey) {
        this.switchAdminAccess();
      }
    },
    isExpiredEmail() {
      if (!this.$user.data.profile || !this.$user.data.profile.email) {
        return false;
      }

      const tempDate = new Date(this.$user.data.created_at);
      tempDate.setDate(tempDate.getDate() + 7);
      return (new Date() > tempDate) && !this.$user.data.profile.email_verified_at && !this.isAdminAccess;
    },
  },
};
</script>

<style lang="scss" src="@/styles/scss/index.scss"></style>
